export interface ResetSystemUserPasswordRequest {
  id: string
  revision: number
}

export function ResetSystemUserPasswordRequestToJSON(
  value: ResetSystemUserPasswordRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
